export const handleKeyPressEnter = (func) => {
    return function (event) {
        if (event.key === 'Enter') {
            func(event);
        }
    };
};
//# sourceMappingURL=handle-keypress-enter.js.map